import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
function CheckRegularGlyph(props, svgRef) {
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", focusable: "false", "aria-hidden": true, ref: svgRef }, props, { children: _jsx("path", { d: "M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z" }, void 0) }), void 0));
}
const ForwardRef = React.forwardRef(CheckRegularGlyph);
export default ForwardRef;
